import SkeletonComponent from "core/components/Skeleton/skeleton";

const RecipeCoupangLoading = () => {
  return (
    <>
      {[...Array(10)].map((_, index) => (
        <SkeletonComponent
          key={index}
          className={`min-w-[76px] h-[76px] mr-1`}
          width={76}
          height={76}
        />
      ))}
    </>
  );
};

export default RecipeCoupangLoading;
